import { render, staticRenderFns } from "./Fpcx.vue?vue&type=template&id=5d70c124&scoped=true&"
import script from "./Fpcx.vue?vue&type=script&lang=js&"
export * from "./Fpcx.vue?vue&type=script&lang=js&"
import style0 from "./Fpcx.vue?vue&type=style&index=0&id=5d70c124&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d70c124",
  null
  
)

export default component.exports